// Shapes shared by the Plane key UI and both data providers. Kept out of the
// Supabase provider module, which builds the Supabase client at import and so
// cannot be loaded by a test or the demo. LCCRM-92.

export type PlaneKeyStatus =
  | { connected: true; email: string | null; verified_at: string }
  | { connected: false };

/** Why plane_key refused a key, carried so the UI can say which. */
export class PlaneKeyError extends Error {
  reason?: "rejected" | "not_member" | "plane_unavailable" | "missing";
  project?: string;
}

/** A push refused because of the pusher's own Plane key, not because of the task. */
export type PlanePushRefusal = "no_plane_key" | "plane_key_rejected";

/**
 * Why a whole push was refused, if it was. Both reasons are about the person
 * pushing, so they are the same for every task in a request and get one message,
 * not one per task.
 */
export const planeRefusal = (
  results: { ok: boolean; reason?: string }[] | null | undefined,
): PlanePushRefusal | null => {
  for (const r of results ?? []) {
    if (r.ok) continue;
    if (r.reason === "no_plane_key" || r.reason === "plane_key_rejected") {
      return r.reason;
    }
  }
  return null;
};

/** Message key for a push the user asked for. */
export const planeRefusalMessage = (reason: PlanePushRefusal): string =>
  reason === "no_plane_key" ? "crm.plane.no_key" : "crm.plane.key_rejected";

/**
 * Plain text for the automatic re-sync after an edit, which runs inside the data
 * provider where there is no translate function. The edit itself was saved.
 */
export const planeNotSyncedText = (reason: PlanePushRefusal): string =>
  reason === "no_plane_key"
    ? "Not synced to Plane, add your Plane API key"
    : "Not synced to Plane, your Plane API key was rejected";
